module.exports = {
    planName: 'lite'
}